export const f = x => 2 * x * (x * x - 1);
export const df = x => 6 * x * x - 2;
export const x0 = 0.41;
export const x = [-1.2, 1.2];
export const y = [-1, 1];
